import {notification} from "antd";
import {ErrorMessage, errorMessageType} from "./errorHelper";
import {onNotFoundWords} from "../core/localization/localizationHelper";
import React from "react";
import {WarningOutlined} from "@ant-design/icons/lib/icons";
import {CheckCircleFilled, CloseOutlined} from "@ant-design/icons";
import {notify} from "../core/components/notification/notifier";
import {bildirimAnahtari, bildirimSuresi, bildirimYerlesimi} from "../core/components/notification/bildirimTercihi";
import {bildirimSesiCal} from "../core/components/notification/bildirimSesi";

export interface NotificationMessage {
    title: string;
    message: string;
    type?: "error" | "success" | "warning";
    notTranslateTitle?: boolean;
    notTranslateMessage?: boolean;
    notTranslate?: boolean;
    showBrowserNotification?: boolean;
}


const isUserActiveOnTab = () => (
    document.visibilityState === "visible" &&
    document.hasFocus() &&
    window.outerHeight > 0
);


type NType = "error" | "warning" | "success";

const PALETTE: Record<NType, { fg: string; bg: string; ring: string; icon: React.ReactNode }> = {
    error: {
        fg: "#d03d07",
        bg: "#fff6f2",
        ring: "#ffe3db",
        icon: <WarningOutlined/>,
    },
    warning: {
        fg: "#e0a100",
        bg: "#fff9e6",
        ring: "#ffefbf",
        icon: <WarningOutlined/>,
    },
    success: {
        fg: "#0c8f47",
        bg: "#effbf4",
        ring: "#d8f4e5",
        icon: <CheckCircleFilled/>,
    },
};


const showBrowserNotification = (title: string, message: string) => {
    if (isUserActiveOnTab()) return;

    if (!("Notification" in window)) {
        console.log("Browser desktop notification desteklemiyor.");
        return;
    }

    const createNotification = () => {
        new Notification(title, {
            body: message,
            icon: "/favicon.ico",
            badge: "/favicon.ico"
        });
    };

    if (Notification.permission === "granted") {
        createNotification();
    } else if (Notification.permission !== "denied") {
        Notification.requestPermission().then(permission => {
            if (permission === "granted") createNotification();
        });
    }
};

export const showAntNotification = (
    type: NType,
    title: string,
    description: string[],
    opts?: { duration?: number; maxWidth?: number }
) => {
    const palette = PALETTE[type];
    const maxWidth = opts?.maxWidth ?? 560;
    bildirimSesiCal(type);

    notification[type]({
        key: bildirimAnahtari(type, opts?.duration),
        className: `mino-notification mino-${type}`,
        duration: bildirimSuresi(type, opts?.duration),
        closeIcon: <CloseOutlined className="mino-bildirim-kapat"/>,
        message: (
            <div className="mino-head">
        <span className="mino-icon-badge" aria-hidden>
          {palette.icon}
        </span>
                <span className="mino-title">{title}</span>
            </div>
        ),
        description: (
            <div className="mino-desc">
                {description.map((line, i) => (
                    <p key={i} className="mino-line">
                        {line}
                    </p>
                ))}
            </div>
        ),
        style: {maxWidth}, // responsive kırpma
        placement: bildirimYerlesimi(),
    });
};
const wrapLine = (line: string, maxWidth: number, result: string[]) => {
    const words = line.split(" ");
    let currentLine = "";

    for (const word of words) {
        // Eğer kelime tek başına çok uzunsa (ör: URL, token)
        if (word.length > maxWidth) {
            // Önce mevcut satırı push et
            if (currentLine) {
                result.push(currentLine.trim());
                currentLine = "";
            }
            // Kelimeyi parçalara böl
            for (let i = 0; i < word.length; i += maxWidth) {
                result.push(word.slice(i, i + maxWidth));
            }
            continue;
        }

        // Normal kelime ekleme
        if (!currentLine) {
            currentLine = word;
        } else if ((currentLine + " " + word).length <= maxWidth) {
            currentLine += " " + word;
        } else {
            // Cümle sonu veya noktalama işaretine göre kırma
            if (/[.,;!?]$/.test(currentLine)) {
                result.push(currentLine.trim());
                currentLine = word;
            } else {
                result.push(currentLine.trim());
                currentLine = word;
            }
        }
    }

    if (currentLine) {
        result.push(currentLine.trim());
    }
};
const wrapText = (text: string, maxWidth = 40): string[] => {
    const result: string[] = [];

    if (text.includes("\r\n")) {
        const lines = text.split("\r\n");
        for (const line of lines) {
            if (line.length > maxWidth) {
                wrapLine(line, maxWidth, result);
            } else {
                result.push(line);
            }
        }
    } else {
        wrapLine(text, maxWidth, result);
    }

    return result;
};


/*

export const SendNotification = async (msg: NotificationMessage) => {
    const title = msg.title ?? (msg.type === "error" ? "Bilinmeyen Hata" : "İşlem Başarılı...");
    const message = msg.message ?? "...";
    const notTranslate = msg.notTranslate || (msg.notTranslateTitle && msg.notTranslateMessage);

    let finalTitle = title;
    let finalMessage = message;

    if (!notTranslate) {
        try {
            const translations = await onNotFoundWords([title, message]);
            finalTitle = msg.notTranslateTitle ? title : translations[title];
            finalMessage = msg.notTranslateMessage ? message : translations[message];
        } catch (err) {
            console.error("Çeviri sırasında hata oluştu:", err);
        }
    }
    if (msg.showBrowserNotification) {
        showBrowserNotification(finalTitle, finalMessage);
    }
    const lines = wrapText(finalMessage, 45);
    showAntNotification(msg.type ?? "success", finalTitle, lines);
};
*/

export const translateFnAdapter = async (
    keys: string[],
    _format?: Record<string, any>
): Promise<Record<string, string>> => {
    //TODO: format desteği yok
    return onNotFoundWords(keys);
};
export const SendNotification = async (msg: NotificationMessage & {
    key?: string;
    placement?: "top" | "topLeft" | "topRight" | "bottomLeft" | "bottomRight" | "bottom";
    maxWidth?: number;
    formatValue?: Record<string, any>;
}) => {
    const fallbackTitle =
        msg.title ?? (msg.type === "error" ? "Bilinmeyen Hata" : "İşlem Başarılı...");
    const fallbackMessage = msg.message ?? "...";

    const notTranslate =
        msg.notTranslate || (msg.notTranslateTitle && msg.notTranslateMessage);

    await notify({
        key: msg.key,
        placement: msg.placement,
        maxWidth: msg.maxWidth,
        type: msg.type ?? "success",
        title: fallbackTitle,
        message: fallbackMessage,
        showBrowserNotification: msg.showBrowserNotification,
        maxLineWidth: 45,
        i18n: {
            notTranslate,
            notTranslateTitle: msg.notTranslateTitle,
            notTranslateMessage: msg.notTranslateMessage,
            formatValue: msg.formatValue,
            translateFn: translateFnAdapter,
        },
    });
};
export const SendNotificationWarning = (message: ErrorMessage) =>
    SendNotification({
        title: message.title,
        message: message.message,
        type: "warning",
        notTranslate: message.type === "server",
        showBrowserNotification: true
    });

export const SendNotificationWarningArg = (title: string, message: string, type: errorMessageType = "react", notTranslate?: boolean) =>
    SendNotification({
        title,
        message,
        type: "warning",
        notTranslate: (type === "server") || (notTranslate === true),
        showBrowserNotification: true
    });

export const SendNotificationError = (message: ErrorMessage) =>
    SendNotification({
        title: message.title,
        message: message.message,
        type: "error",
        notTranslate: (message?.type === "server") || message.notTranslate,
        showBrowserNotification: true
    });

export const SendNotificationErrorArg = (title: string, message: string, type: errorMessageType = "react", notTranslate?: boolean) =>
    SendNotification({
        title,
        message,
        type: "error",
        notTranslate: (type === "server") || (notTranslate === true),
        showBrowserNotification: true
    });

export const SendNotificationErrorMessage = (message: string, type: errorMessageType = "react", notTranslate?: boolean) =>
    SendNotification({
        title: "Hata",
        message,
        type: "error",
        notTranslate: type === "server",
        showBrowserNotification: true
    });

export const SendNotificationSuccessArg = (title: string, message: string, type: errorMessageType = "react", notTranslate?: boolean) =>
    SendNotification({
        title,
        message,
        type: "success",
        notTranslate: (type === "server") || (notTranslate === true),
        showBrowserNotification: true
    });

export const SendNotificationSuccess = (message: ErrorMessage) =>
    SendNotification({
        title: message.title,
        message: message.message,
        type: "success",
        notTranslate: (message?.type === "server") || message.notTranslate,
        showBrowserNotification: true
    });
